// extracted by mini-css-extract-plugin
export default {"container":"Gvt_LN","text":"oiYYuj","block":"Ii3Ak8"};